import React from 'react';

import Header from '~/components/Header';
import Intro from '~/components/Intro';
import Section02 from '~/components/Section02';
import Section03 from '~/components/Section03';
import Section04 from '~/components/Section04';
import Section05 from '~/components/Section05';
import Section06 from '~/components/Section06';
import Footer from '~/components/Footer';

import GlobalStyle from './styles/global';

import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <>
      <GlobalStyle />
      <Header />
      <Intro />
      <Section02 />
      <Section03 id="projetos" />
      <Section04 id="passoapasso" />      
      <Section05 id="depoimentos" />
      <Section06 id="faq" />
      <Footer id="contato" />
    </>
  );
}

export default App;
